import type { TrainingLessonSpecific } from './trainingLessonUi';

export const core3PriesthoodEs: TrainingLessonSpecific = {
  intro:
    'El sacerdocio es el poder y la autoridad de Dios para actuar en Su nombre. En esta lección explorarás la diferencia entre autoridad y poder, el significado de las llaves, y cómo se ejerce a través del servicio y la rectitud.',
  objectives: [
    'Entender qué es el sacerdocio y por qué existe.',
    'Diferenciar autoridad vs poder del sacerdocio.',
    'Diferenciar llaves del sacerdocio vs autoridad delegada.',
    'Comprender la diferencia y propósito del Aarónico y el de Melquisedec.',
    'Identificar hábitos prácticos para ejercer el sacerdocio con dignidad y reverencia.',
  ],
  briefHeading: 'El Sacerdocio: autoridad, llaves y servicio',
  briefBody:
    'La autoridad del sacerdocio es el derecho de actuar en nombre de Dios; el poder depende de la rectitud, fe, humildad y obediencia. Las llaves son el derecho de presidir y dirigir cómo se usa la autoridad en un área. El sacerdocio Aarónico se enfoca en ordenanzas preparatorias y ministerio; el de Melquisedec en las ordenanzas espirituales y el gobierno de la Iglesia. Se ejerce mediante el servicio y la dignidad. Para organización y deberes en la Iglesia, profundiza con el Manual General (cap. 3) en ChurchofJesusChrist.org.',
  scriptures: [
    {
      ref: 'DyC 13',
      text: 'Upon you my fellow servants, in the name of Messiah I confer the Priesthood of Aaron...',
    },
    {
      ref: 'DyC 20:38–60',
      text: 'Deberes de oficios: bautismo, Santa Cena, bendiciones y ordenanzas.',
    },
    {
      ref: 'DyC 107:1–20',
      text: 'There are, in the church, two priesthoods...',
    },
    {
      ref: 'Mateo 16:19',
      text: 'Y a ti te daré las llaves del reino de los cielos...',
    },
    {
      ref: 'Hebreos 5:4',
      text: 'Y nadie toma para sí esta honra, sino el que es llamado de Dios...',
    },
  ],
  didYouKnow: [
    'Las llaves no son "más poder": son el derecho de presidir y dirigir cómo se usa la autoridad del sacerdocio en un área (barrio, estaca, ordenanzas).',
    'El poder del sacerdocio no "se enciende" por el cargo: se manifiesta con rectitud, fe, humildad y obediencia. La autoridad puede estar; el poder depende del corazón.',
  ],
  practiceItems: [
    'Explicar con tus palabras la diferencia entre autoridad y poder del sacerdocio (1–2 líneas)',
    'Explicar con tus palabras qué son las llaves del sacerdocio (1–2 líneas)',
    'Identificar en tu barrio quién preside con llaves (obispo / presidente de estaca) y por qué',
    'Antes de la Santa Cena, hacer una preparación simple: oración + revisar tu conducta + reverencia',
    'Practicar reverencia: llegar 10 minutos antes y sentarte listo sin distracciones (1 domingo)',
    'Elegir 1 acto de servicio silencioso esta semana (sin anunciarlo ni postearlo)',
  ],
  reflectionQuestions: [
    '¿En qué área de mi vida necesito más "poder" del sacerdocio (más fe y obediencia), aunque ya tenga autoridad o acceso a ordenanzas?',
    '¿Qué me cuesta entender más: llaves, oficios o dignidad? ¿Por qué?',
    '¿Qué haré diferente este domingo para honrar el sacerdocio y la Santa Cena?',
  ],
  actionText:
    'Preparación dominical: Esta semana, escoge una cosa concreta para llegar al domingo más preparado (ej.: dejar la ropa lista, dormir más temprano, leer 1 escritura, pedir perdón, apagar el celular en la reunión).',
};
